module.exports = __webpack_public_path__ + "img/7passenger_driving.9b33fa25.svg";